import type UserMlsRoster from '@bb/domain/dist/types/UserMlsRoster';
import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';

const upsertOneRosterQa = async ({
  updates,
  rosterType,
}: {
  updates: UserMlsRoster;
  rosterType:
    | 'usermlsroster'
    | 'usermlsrosterinactive'
    | 'usermlsrosternonagent';
}) => {
  const config: AxiosRequestConfig = {
    method: 'POST',
    url: '/roster/qa_page',
    data: {
      updates,
      rosterType,
    },
  };

  const { data } = await axios.request<{ newEntryCreated: boolean }>(config);

  return data;
};

export default upsertOneRosterQa;
